import React, { FC } from "react";
import { Box, BoxProps } from "theme-ui";

export type AccordionType = BoxProps & {
  item?: boolean;
};
export const Accordion: FC<AccordionType> = ({
  item,
  children,
  ...props
}: AccordionType) => (
  <Box
    variant={
      item ? "boxes.backgrounds.accordion.item" : "boxes.backgrounds.accordion"
    }
    {...props}
  >
    {children}
  </Box>
);

Accordion.defaultProps = {
  item: false,
};
